// extracted by mini-css-extract-plugin
module.exports = {"social_sharing":"QNWRv","timespoint":"VidHq","topsticky":"TXtBc","facebook":"yPp2s","twitter":"qlvur","mail":"xeLwX","socialSharingWithText":"oQEkc"};